module.exports = __webpack_public_path__ + "static/media/menu-1.d407b693.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/menu-1.jpg
// module id = 153
// module chunks = 0